import { z } from 'zod';

/** A 6-digit TOTP code. */
export const totpCodeSchema = z
  .string()
  .trim()
  .regex(/^\d{6}$/, 'enter the 6-digit code');

/** The second sign-in step accepts a TOTP code or one of the recovery codes. */
export const mfaVerifyRequestSchema = z.object({ code: z.string().trim().min(6).max(32) });

export const mfaEnableRequestSchema = z.object({ code: totpCodeSchema });

export const mfaRegenerateRequestSchema = z.object({ code: totpCodeSchema });

/**
 * Turning the second factor off needs a fresh code from the app. Platform staff cannot turn it
 * off (it is required for them); store staff can (KNOWN_ISSUES K19).
 */
export const mfaDisableRequestSchema = z.object({ code: totpCodeSchema });

export const mfaStatusSchema = z.object({
  enabled: z.boolean(),
  /** Platform staff cannot use the platform surface without a second factor. */
  required: z.boolean(),
  recoveryCodesRemaining: z.number().int().nonnegative(),
  /**
   * Development only (`MFA_DEV_CODES`): the current code, so no authenticator app is needed.
   * Never present in staging or production.
   */
  devCode: z.string().optional(),
});
export type MfaStatus = z.infer<typeof mfaStatusSchema>;

/** Returned when enrollment starts. The secret is also inside `otpauthUri` (for the QR code). */
export const mfaSetupResponseSchema = z.object({
  secret: z.string(),
  otpauthUri: z.string(),
  /**
   * Development only (`MFA_DEV_CODES`): the current code, so no authenticator app is needed.
   * Never present in staging or production.
   */
  devCode: z.string().optional(),
});
export type MfaSetupResponse = z.infer<typeof mfaSetupResponseSchema>;

/** Shown exactly once; only their hashes are stored. */
export const recoveryCodesResponseSchema = z.object({
  recoveryCodes: z.array(z.string()),
});
export type RecoveryCodesResponse = z.infer<typeof recoveryCodesResponseSchema>;
